module.exports = __webpack_public_path__ + "img/flow-close-icon.69f4e1c6.svg";